<div class="summary">
  @if (!data.hideBadge) {
    <div
      [class]="['badge', data.typeClass]"
      >
      {{data.type}}
    </div>
  }
  <!-- A host's own pill in the badge's place (the issue stage pill) -->
  <ng-content />
  @if (data.status) {
    <div
      class="status-section"
      >
      @if (data.icon) {
        <mat-icon
          [svgIcon]="data.icon"
          />
      }
      <div [class]="['status', data.statusClass]">
        {{data.status}}
      </div>
    </div>
  }
  <div class="date">
    {{data.date}}
  </div>
</div>
